import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VLayout,{attrs:{"row":"","wrap":""}},[(_vm.tiposPagamento && _vm.tiposMaquineta)?_c(VFlex,{attrs:{"xs12":""}},[_c('pagamentos-extras')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }